import type { CreationAsset } from '@djgg/creations';

export const ASSET_LIBRARY_FILTERS = [
  ['all', 'All'],
  ['visuals', 'Visuals'],
  ['animation', 'Animation'],
  ['music', 'Music'],
  ['sound-effects', 'Sound effects'],
] as const;

export type AssetLibraryFilter = (typeof ASSET_LIBRARY_FILTERS)[number][0];

export function assetMatchesLibraryFilter(filter: AssetLibraryFilter, kind: CreationAsset['kind']): boolean {
  if (filter === 'all') return true;
  if (filter === 'animation') return kind === 'strip';
  if (filter === 'music') return kind === 'music';
  if (filter === 'sound-effects') return kind === 'sfx';
  return filter === 'visuals' && kind !== 'strip' && kind !== 'music' && kind !== 'sfx';
}

/** One Assets destination; filters change the current library view only. */
export function AssetLibraryNavigation({ active, onChange }: {
  active: AssetLibraryFilter;
  onChange: (filter: AssetLibraryFilter) => void;
}) {
  return <nav className="tabs" aria-label="Assets library filters" style={{ marginTop: 14, width: '100%', flexWrap: 'wrap' }}>
    {ASSET_LIBRARY_FILTERS.map(([filter, label]) => (
      <button key={filter} type="button" className={`tab${active === filter ? ' tab--active' : ''}`}
        aria-pressed={active === filter} onClick={() => onChange(filter)} data-testid={`asset-library-filter-${filter}`}>
        {label}
      </button>
    ))}
  </nav>;
}
